import {Component, Input} from '@angular/core';
import {NgIf, NgFor} from '@angular/common';
import {MatDividerModule} from '@angular/material/divider';
import {TranslateModule} from '@ngx-translate/core';
import {TrainingHintInterface} from '../models/training-model';
import {InterpolatePipe} from '../../../diagram-render/helpers/interpolate.pipe';
import {ConfigService, getFullName, Q9TransformPipe} from '@q9elements/ui-kit/common';
import {UserInfoComponent} from '@q9elements/ui-kit/components';

@Component({
  selector: 'app-training-popup',
  templateUrl: './training-popup.component.html',
  styleUrls: ['./training-popup.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatDividerModule,
    NgFor,
    UserInfoComponent,
    InterpolatePipe,
    TranslateModule,
    Q9TransformPipe
  ]
})
export class TrainingPopupComponent {
  @Input() config: TrainingHintInterface | any;
  @Input() diagramHistory;

  readonly getFullName = getFullName;

  TASK_LIST_URL = `${ConfigService.environment.MAIN_APP_URL}/tasks?ref=active&list=assigned-to-me`;
  anchorTarget: string = window.top !== window.self ? '_self' : '_blank';
}
